import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ebb-portal-dialog-pdfread',
    templateUrl: './dialog-pdfread.component.html',
    styleUrls: ['./dialog-pdfread.component.scss'],
    standalone: false
})
export class DialogPdfReadComponent implements OnInit {
  totalPages = 0;
  canComplete = false;

  // The PDF viewer accepts string | Blob | ArrayBuffer | Uint8Array
  pdfSrc: Uint8Array | ArrayBuffer | Blob | string | null = null;

  constructor(
    private ref: MatDialogRef<DialogPdfReadComponent>,
    // Allow passing either a URL or raw bytes from the caller
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      url?: string;
      bytes?: Uint8Array | ArrayBuffer | Blob | string;
      base64?: string;
    }
  ) {}
private lastPageObserver?: IntersectionObserver;
  ngOnInit(): void {
    if (this.data?.url) {
      this.pdfSrc = this.data.url;
    }
  }

  onPagesLoaded(evt: { pagesCount: number }) {
  this.totalPages = evt.pagesCount;
  // Give PDF a tick to render DOM nodes
  setTimeout(() => this.observeLastPage(), 0);
}private observeLastPage() {
  this.lastPageObserver?.disconnect();

  const container = document.getElementById('viewerContainer'); // provided by the pdf viewer
  const lastPage = document.querySelector(`.page[data-page-number="${this.totalPages}"]`);

  if (!container || !lastPage) return;

  this.lastPageObserver = new IntersectionObserver(
    entries => {
      const e = entries[0];
      if (e.isIntersecting && e.intersectionRatio >= 0.75) {
        this.canComplete = true;
        this.lastPageObserver?.disconnect();
      }
    },
    { root: container, threshold: [0.75] }
  );

  this.lastPageObserver.observe(lastPage);
}

onPageChange(pageNumber: number) {
  // keep for desktop or immediate success when user jumps to last page
  if (this.totalPages > 0 && pageNumber >= this.totalPages) {
    this.canComplete = true;
  }
}

  close(ok: boolean) {
    this.ref.close(ok);
  }
}
